import { gql } from '@apollo/client';

const 

/** @description create new post */

CREATE_MEMBER = gql`mutation CreateMember (

    $firstName: String!

    $lastName: String!

    $image: Upload

    $title: String!

    $phone: String!

    $email: String!

) {

    adminCreateContact (

        input: {

            contactsInput: {

                firstName: $firstName

                lastName: $lastName

                image: $image

                title: $title

                phone: $phone

                email: $email

            }

        }

    ) {

        contact {

            id

        }

    }

}`,

/** @description update existing post */

UPDATE_MEMBER = gql`mutation UpdateMember (

    $id: ID!

    $firstName: String!

    $lastName: String!

    $image: Upload

    $title: String!

    $phone: String!

    $email: String!

) {

    adminUpdateContact (

        input: {

            id: $id

            contactsInput: {

                firstName: $firstName

                lastName: $lastName

                image: $image

                title: $title

                phone: $phone

                email: $email

            }

        }

    ) {

        contact {

            createdAt
      
            email
            
            firstName
            
            id
            
            image
            
            lastName
            
            phone
            
            title
            
            updatedAt

        }

    }

}`,

/** @description delete existing post */

DELETE_MEMBER = gql`mutation DeleteMember (

    $id: ID!

) {

    adminDeleteContact (

        input: {

            id: $id

        }

    ) {

        contact {

            id

        }

    }

}`,

/** @description create new legal data */

CREATE_LEGAL_DATA = gql`mutation CreateLegalData (

    $legalEntityName: String!

    $registrationNumber: String!

    $countryCode: String

    $legalAddress: String

    $factualAddress: String

    $phone: String

    $servicePhone: String

    $email: String

    $bankAccountsAttributes: [BankAccountAttributes!]

) {

    adminCreateLegalData (

        input: {

            legalDataInput: {

                legalEntityName: $legalEntityName

                registrationNumber: $registrationNumber

                countryCode: $countryCode

                legalAddress: $legalAddress

                factualAddress: $factualAddress

                phone: $phone

                servicePhone: $servicePhone

                email: $email

                bankAccountsAttributes: $bankAccountsAttributes

            }

        }

    ) {

        legalData {

            id

        }

    }

}`,

/** @description update existing legal data */

UPDATE_LEGAL_DATA = gql`mutation UpdateLegalData (

    $id: ID!

    $legalEntityName: String!

    $registrationNumber: String!

    $countryCode: String

    $legalAddress: String

    $factualAddress: String

    $phone: String

    $servicePhone: String

    $email: String

    $bankAccountsAttributes: [BankAccountAttributes!]

) {

    adminUpdateLegalData (

        input: {

            id: $id

            legalDataInput: {

                legalEntityName: $legalEntityName

                registrationNumber: $registrationNumber

                countryCode: $countryCode

                legalAddress: $legalAddress

                factualAddress: $factualAddress

                phone: $phone

                servicePhone: $servicePhone

                email: $email

                bankAccountsAttributes: $bankAccountsAttributes

            }

        }

    ) {

        legalData {

            id

            legalEntityName

            registrationNumber

            countryCode

            legalAddress

            factualAddress

            phone

            servicePhone

            email

            createdAt

            updatedAt

            bankAccounts {

                id

                iban

                bankName

                swiftCode

                isEnabled

                isDefault

            }

        }

    }

}`,

/** @description delete existing legal data */

DELETE_LEGAL_DATA = gql`mutation DeleteLegalData (

    $id: ID!

) {

    adminDeleteLegalData (

        input: {

            id: $id

        }

    ) {

        success

    }

}`;

/** @export mutations */

export {

    CREATE_MEMBER,

    UPDATE_MEMBER,

    DELETE_MEMBER,

    CREATE_LEGAL_DATA,

    UPDATE_LEGAL_DATA,

    DELETE_LEGAL_DATA

}